<template>
  <div class="chat-tabs">


    <HeaderMain
      :hideOrderButton="true"
      title="Чаты"
    /> 
    <!-- Вкладки -->
    <div class="tabs">
      <button
        v-for="(tab, index) in tabs"
        :key="index"
        :class="{ active: activeTab === index }"
        @click="switchTab(index)"
        class="tab-button"
      >
        {{ tab }}
      </button>
    </div>
    

   <!-- Фильтр по дате для вкладки "Все чаты" -->
      <div v-if="activeTab === 2 || activeTab === 3" class="date-picker-wrapper">
        <div class="filter-block">
          <label class="filter-label" for="chat-date">Фильтр по дате:</label>
          <input
            id="chat-date"
            type="date"
            class="filter-input"
            v-model="selectedDate"
            @change="handleDateChange"
            :max="getTodayDateString()"
          />
        </div>
      </div>



    <!-- Содержимое вкладок -->
    <div class="tab-content">
      <div v-if="loading" class="loading">Загрузка...</div>
      <div v-if="error" class="error">{{ error }}</div>
      <div v-if="nochats">По пользователю {{ $store.state.user.label }} чатов не найдено</div>
      
      <div class="el-row d-flex flex-wrap" v-if="!loading && chats.length > 0">
        <div
          v-for="chat in chats"
          :key="chat.clientId"
          class="el-col el-col-24 el-col-md-8 is-guttered flex-fill"
          style="padding-right: 10px; padding-left: 10px; padding-bottom: 20px;"
        >
          <div class="el-card is-always-shadow cursor-pointer h-100" @click="openChat(chat)">
            <div class="el-card__body">
              <!-- Заголовок чата -->
              <div class="el-card-section pt-0 pb-0">
                <div class="d-flex w-100 align-items-center" style="min-height: 4.5em;">
                  <h5 class="m-0 el-tooltip__trigger">
                    <i class="fab fa-telegram-plane mr-2" style="color: rgb(23, 156, 222);"></i>
                  </h5>
                  <div class="flex-fill d-inline-block text-truncate">
                    <h5 class="m-0 text-truncate">{{ chat.name }}</h5>
                  </div>
                  <h5 class="m-0 ml-2 text-nowrap font-weight-normal">
                    <i class="far fa-envelope text-orange mr-1"></i> {{ chat.messages.length }}
                  </h5>
                </div>
              </div>

              <!-- Последние 5 сообщений -->
              <div class="el-card-section pt-0 pb-0">
                <div class="core-ui-chat-history">
                  <div
                    v-for="message in getLastMessages(chat)"
                    :key="message.id"
                    :class="[
                      'chat-history-message',
                      `chat-history-message-${message.id}`,
                      message.whoSend === 'client' ? 'color-client-default' : 'color-blue',
                      message.whoSend === 'operator' ? 'operator' : 'client',
                      message.isVisibleForClient ? 'last-message-of' : '',
                      'short-margin',
                      'is-bubble-message'
                    ]"
                    :data-core-ui-chat-history-message-with-id="message.id"
                  >
                    <div class="d-flex inner">
                      <div class="message-wrapper flex-fill">
                        <div class="message-background-container message-background message-content-color">
                          <div class="sender-name message-color">
                            {{ message.whoSend === 'client' ? 'Посетитель' : message.operatorName || 'Оператор' }}
                            <i v-if="message.whoSend === 'client'" class="-icon fal fa-arrow-right"></i>
                          </div>
                          <div class="message-text">
                            {{ message.text }}
                          </div>
                          <div class="time message-color time">
                            <span class="time-value">{{ formatDate(message.dateTime) }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="core-ui-avatar avatar" :style="{ background: 'rgb(189, 195, 199)', width: '30px', height: '30px', minWidth: '30px' }" v-if="message.whoSend === 'operator'">
                       <img v-if="chat.operators[0] && chat.operators[0].avatar" :src="chat.operators[0].avatar" alt="avatar" />

                        <span v-else class="status text-status-1" style="font-size: 30px;">
                          <span class="status-circle"></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <ChatsTabSidebar 
      :visible="visibleSidebar"
      :chat="selectChat"
      @close="closeSidebar"
      />
    </div>
  </div>
</template>

<script>

import HeaderMain from '@/components/HeaderMain.vue'
import ChatsTabSidebar from '@/components/ChatsTabSidebar.vue'
import { mapState, mapActions, mapGetters } from 'vuex'


export default {
  components: { HeaderMain, ChatsTabSidebar },
  data() {
    return {
      visibleSidebar: false,
      selectChat: null,
      defaultAvatar: "https://via.placeholder.com/30", // Default avatar
    };
  },
  computed: {
    ...mapState('chatModule', [
      'activeTab',
      'tabs',
      'loading',
      'error',
      'selectedDate',
      'chats',
      'newMessages'
    ]),
    ...mapGetters('chatModule', [
      'currentChats',
      'unreadChatsCount',
      'hasNewMessages'
    ]),
    nochats() {
      return this.chats.length === 0 && !this.loading && !this.error;
    }
  },
  methods: {
    ...mapActions('chatModule', [
      'fetchChats',
      'sendMessage',
      'getClientMessages',
      'markMessageAsRead'
    ]),
    
    getTodayDateString() {
      const today = new Date();
      const pad = (n) => String(n).padStart(2, "0");
      return `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    },
    
    openSidebar(){
      this.visibleSidebar = true;
    },
    
    closeSidebar(){
      this.visibleSidebar = false;
    },
    
    async switchTab(index) {
      this.$store.commit('chatModule/SET_ACTIVE_TAB', index);
      await this.fetchChats();
    },
    
    async handleDateChange() {
      this.$store.commit('chatModule/SET_SELECTED_DATE', this.selectedDate);
      await this.fetchChats();
    },
    getLastMessages(chat) {
      // Возвращает последние 5 сообщений чата
      return chat.messages.slice(-5).reverse();
    },
    formatDate(dateTime) {
      // Форматирует дату и время
      const date = new Date(dateTime);
      return date.toLocaleString("ru-RU", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    async openChat(chat) {
      console.log('Клик по чату:', chat);
      console.log('Структура чата:', JSON.stringify(chat, null, 2));
      this.selectChat = chat;
      this.$store.commit('chatModule/SET_CURRENT_CHAT', chat);
      console.log('Открываем чат:', chat);
      console.log('selectChat установлен:', this.selectChat);
      
      // Загружаем сообщения для этого чата
      try {
        // Получаем dialogId из первого сообщения
        const dialogId = chat.messages && chat.messages.length > 0 ? chat.messages[0].dialogId : null;
        
        const payload = {
          clientId: chat.clientId,
          limit: 30,
          page: 0
        };
        
        // Если есть dialogId, добавляем его
        if (dialogId) {
          payload.dialogId = dialogId;
          console.log('Используем dialogId:', dialogId);
        } else {
          console.log('dialogId не найден, используем clientId');
        }
        
        console.log('Отправляем payload:', payload);
        await this.getClientMessages(payload);
        console.log('Сообщения загружены');
      } catch (error) {
        console.error('Ошибка загрузки сообщений:', error);
        // Не прерываем открытие чата, даже если сообщения не загрузились
      }
      
      this.openSidebar();
      console.log('Sidebar открыт:', this.visibleSidebar);
    },
  },
  mounted() {
    this.fetchChats();
  },
  watch: {
    selectedDate() {
      this.handleDateChange();
    }
  }
};
</script>

<style scoped>
.chat-tabs {
  width: 100%;
  margin: 0 auto;
}

.tabs {
  display: flex;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;
}

.tab-button {
  flex: 1;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  border: none;
  background: #f9f9f9;
  font-size: 16px;
  transition: background-color 0.2s ease;
}

.tab-button:hover {
  background: #ddd;
}

.tab-button.active {
  background: #fff;
  border-bottom: 2px solid #000;
  font-weight: bold;
}

.tab-content {
  padding: 10px;
}

.chat-item {
  cursor: pointer;
  padding: 10px;
  border-bottom: 1px solid #ccc;
  transition: background-color 0.2s;
}

.chat-item:hover {
  background: #f0f0f0;
}

.loading {
  text-align: center;
  font-size: 16px;
}

.error {
  color: red;
  text-align: center;
}




.d-flex {
    display: -webkit-box!important;
    display: -webkit-flex!important;
    display: -ms-flexbox!important;
    display: flex!important;
}

.flex-wrap {
    -webkit-flex-wrap: wrap!important;
    -ms-flex-wrap: wrap!important;
    flex-wrap: wrap!important;
}

.el-row {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    position: relative;
}
.el-col-24, .el-col-24.is-guttered {
    display: block;
}






.flex-fill {
    -webkit-box-flex: 1!important;
    -webkit-flex: 1 1 auto!important;
    -ms-flex: 1 1 auto!important;
    flex: 1 1 auto!important;
}

[class*=el-col-] {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}


.el-col-24 {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 100%;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}

.el-col-md-8 {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 33.3333333333%;
    -ms-flex: 0 0 33.3333333333%;
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
}

[class*=el-col-].is-guttered {
    display: block;
    min-height: 1px;
}







.el-card {
    --el-card-border-color: #e4e7ed;
    --el-card-border-radius: 0.625rem;
    --el-card-padding: 20px;
    --el-card-bg-color: #fff;
    background-color: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 20px;
    color: #303133;
    color: #303133;
    overflow: hidden;
    -webkit-transition: .3s;
    transition: .3s;
   
}

.el-card {
    overflow: visible;
}

.h-100 {
    height: 100%!important;
}

.cursor-pointer {
    cursor: pointer!important;
}


.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
    -webkit-box-shadow: 0 0 12px rgb(0 0 0 / 12%);
    box-shadow: 0 0 12px rgb(0 0 0 / 12%);
    -webkit-box-shadow: var(--el-box-shadow-light);
    box-shadow: var(--el-box-shadow-light);
}

.lcabLayout .cabinet-controller .el-row-root>.el-col .el-card, .lcabLayout .cabinet-controller>.el-row>.el-col .el-card {
    margin-bottom: 1.75rem;
}





.el-card__body {
    padding: var(--el-card-padding);
}

.el-card-section, .el-card__body, .el-collapse-item__header {
    padding: 1rem;
}

.el-card__body {
    border-radius: inherit;
}



:first-child>.el-card-section:first-child {
    border-top-left-radius: 0.625rem;
    border-top-right-radius: 0.625rem;
}

.el-card-section>:first-child.el-card-section, .el-card-section>:first-child.el-form-wraper, .el-card-section>:first-child.my-table-wrapper, .el-card__body>:first-child.el-card-section, .el-card__body>:first-child.el-form-wraper, .el-card__body>:first-child.my-table-wrapper {
    margin-top: -1rem;
}



.pt-0, .py-0 {
    padding-top: 0!important;
}

.pb-0, .py-0 {
    padding-bottom: 0!important;
}


.el-card-section, .el-card__body, .el-collapse-item__header {
    padding: 1rem;
}


.el-card-section {
    background: #fff;
    margin: 0 -1rem;
    position: relative;
}

.el-card-section {
    border-bottom: 1px solid #e4e7ed;
}



.d-inline-block {
    display: inline-block!important;
}

.flex-fill {
    -webkit-box-flex: 1!important;
    -webkit-flex: 1 1 auto!important;
    -ms-flex: 1 1 auto!important;
    flex: 1 1 auto!important;
}

.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}


.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}




.ml-2, .mx-2 {
    margin-left: 0.5rem!important;
}

.text-nowrap {
    white-space: nowrap!important;
}

.font-weight-normal {
    font-weight: 400!important;
}



.el-card-section:last-child {
    border-bottom: 0;
}

.el-card-section, .el-card__body, .el-collapse-item__header {
    padding: 1rem;
}

.el-card-section>:last-child.el-card-section, .el-card-section>:last-child.el-form-wraper, .el-card-section>:last-child.my-table-wrapper, .el-card__body>:last-child.el-card-section, .el-card__body>:last-child.el-form-wraper, .el-card__body>:last-child.my-table-wrapper {
    margin-bottom: -1.1rem;
}

:last-child>.el-card-section:last-child {
    border-bottom-left-radius: 0.625rem;
    border-bottom-right-radius: 0.625rem;
}

.core-ui-chat-history {
  display: flex;
  flex-direction: column-reverse; /* Последнее сообщение будет внизу */
 
}


.core-ui-chat-history .centered-bubble-info {
    color: var(--el-color-primary);
    padding: 0.75em 0;
    pointer-events: none;
    text-align: center!important;
    z-index: 1;
}

.core-ui-chat-history .centered-bubble-info>span {
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background: hsla(0,0%,100%,.85);
    background: var(--transparent-info-block-background);
    border-radius: 16px;
    -webkit-box-shadow: 0 2px 5px 0 rgb(50 50 105 / 15%), 0 1px 1px 0 rgb(0 0 0 / 5%);
    box-shadow: 0 2px 5px 0 rgb(50 50 105 / 15%), 0 1px 1px 0 rgb(0 0 0 / 5%);
    display: inline-block;
    padding: 0.5em 1em;
    pointer-events: all;
}



.chat-history-message {
    border-radius: 10px;
    padding: 0.25em 0;
    -webkit-transition: background .2s linear;
    transition: background .2s linear;
}


.chat-history-message.color-blue {
    --message-background-color: #b3e5fc;
    --message-background-shadow-color: #9addfb;
    --message-background-darken-color: #275970;
}



.chat-history-message.operator>.inner {
    padding-left: 60px;
}


.chat-history-message.operator.short-margin>.inner {
    padding-left: 15px;
}







.chat-history-message .message-wrapper{
    min-width: 0;
}



.chat-history-message .message-background-container {
    border-radius: 10px;
    display: inline-block;
    max-width: 100%;
    padding: 0.75em;
    position: relative;
    text-align: left;
}

.chat-history-message.color-blue .message-background {
    background: #b3e5fc;
}

.chat-history-message.color-blue .message-background-container {
    border-color: #b3e5fc;
    -webkit-box-shadow: 0 2px 0 #9addfb;
    box-shadow: 0 2px 0 #9addfb;
}


.chat-history-message.color-blue .message-content-color {
    color: #2b2d30;
}

.chat-history-message.operator.last-message-of .message-background-container{
    border-bottom-right-radius: 0;
}

.chat-history-message.operator .message-wrapper{
    text-align: right;
}




.chat-history-message .sender-name {
    font-weight: 500;
    margin-bottom: 0.5em;
    word-break: break-word;
}

.chat-history-message.color-blue .message-color {
    color: #275970;
}


.chat-history-message .message-text {
    word-break: break-word;
    line-height: 16px;
}

.htmlify.pre {
    white-space: pre-wrap!important;
}


.time-value {
  font-size: 10px;
}

.time {
    float: right;
    margin: 0.3em 0 0 1em;
}


.chat-history-message.color-blue .message-color {
    color: #275970;
}



.chat-history-message.last-message-of .message-background-container:after {
    border: solid rgba(0,0,0,0);
    border-width: 0.4em 0 0;
    bottom: 0;
    -webkit-box-shadow: inherit;
    box-shadow: inherit;
    content: " ";
    height: 0;
    position: absolute;
    width: 0;
}


.chat-history-message.operator.last-message-of .message-background-container:after {
    border-left-color: inherit;
    border-left-width: 0.6em;
    left: 100%;
}




.core-ui-avatar {
    border-radius: 50%;
    color: #fff;
    display: inline-block;
    position: relative;
    text-align: center;
}

.chat-history-message .avatar {
    -webkit-align-self: flex-end;
    -ms-flex-item-align: end;
    align-self: flex-end;
    visibility: hidden;
}

.chat-history-message.last-message-of .avatar {
    visibility: visible;
}


.chat-history-message.operator .avatar {
    margin-left: 1em;
}




.text-status-1 {
    color: #1abc9c!important;
}


.core-ui-avatar .status {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
}

.core-ui-avatar .status>span {
    background: #fff;
    border: 2px solid rgba(0,0,0,0);
    border-radius: 50%;
    bottom: -0.3em;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    font-size: .25em;
    height: 1em;
    line-height: 0;
    position: absolute;
    right: -0.3em;
    text-align: center;
    width: 1em;
}



.core-ui-avatar .status>span>* {
    line-height: 1em;
}

.core-ui-avatar .status .status-circle {
    background: currentColor;
    border-radius: 50%;
    display: inline-block;
    height: 100%;
    width: 100%;
}



.chat-history-message {
    border-radius: 10px;
    padding: 0.25em 0;
    -webkit-transition: background .2s linear;
    transition: background .2s linear;
}

.chat-history-message.color-client-default {
    --message-background-color: #f3f4f9;
    --message-background-shadow-color: #e2e4f1;
    --message-background-darken-color: #44526a;
}

.chat-history-message.client.short-margin>.inner {
    padding-right: 15px;
}

.chat-history-message .message-wrapper {
    min-width: 0;
}

.chat-history-message {
    border-radius: 10px;
    padding: 0.25em 0;
    -webkit-transition: background .2s linear;
    transition: background .2s linear;
}

.is-system-info {
    padding-bottom: 0.05em;
}

.chat-history-message.color-blue {
    --message-background-color: #b3e5fc;
    --message-background-shadow-color: #9addfb;
    --message-background-darken-color: #275970;
}


.chat-history-message.color-notification {
    --message-background-color: #ffd7b0;
    --message-background-shadow-color: #ffca97;
    --message-background-darken-color: #6f4f03;
}

.is-system-info+.is-system-info{
    padding-top: 0.05em;
}

.chat-history-message.operator.short-margin>.inner{
    padding-left: 15px;
}



.chat-history-message .message-wrapper {
    min-width: 0;
}

.chat-history-message.operator .message-wrapper{
    text-align: right;
}

.system-info-message-container {
    -webkit-backdrop-filter: blur(3px);
    backdrop-filter: blur(3px);
    background: hsla(0,0%,100%,.85);
    background: var(--operator-app-system-message-background);
    border-radius: 7px;
    display: inline-block;
    font-size: .9em;
    padding: 0.5em 1em;
}


.chat-history-message.color-client-default .message-background-container {
    background: #f3f4f9;
    border-color: #f3f4f9;
    -webkit-box-shadow: 0 2px 0 #e2e4f1;
    box-shadow: 0 2px 0 #e2e4f1;
}

.chat-history-message.client.last-message-of .message-background-container:after {
    border-right-color: inherit;
    border-right-width: 0.6em;
    right: 100%;
}

.chat-history-message.last-message-of .message-background-container:after {
    border: solid rgba(0,0,0,0);
    border-width: 0.4em 0 0;
    bottom: 0;
    -webkit-box-shadow: inherit;
    box-shadow: inherit;
    content: " ";
    height: 0;
    position: absolute;
    width: 0;
}
.core-ui-avatar.avatar img {
  width: 100%;
}



.btn-wrapper.btn-wrapper_group.new.megamenu .custmenu {
  background: #005eeb;
    border: none;
    color: #fff;
    border-radius: 6px;
    transition: 0.3s;
    margin-right: 15px;
}
.btn-wrapper.btn-wrapper_group.new.megamenu .custmenu:hover {
  background: #1170ff;
}

.btn-wrapper.btn-wrapper_group.new.megamenu {
  display: flex;
  align-items: center;
  justify-content: center;
}


.btn.grens {
  background: #1abc9c !important;
}

.megamenu {
  position: relative;
}
.megamenu .allitem {
  display: flex;
  width: 300px;
  position: absolute;
  flex-wrap: wrap;
  top: 60px;
  z-index: 10;
  padding: 20px;
  background: #f4f6f8;
  padding-top: 5px;
}

 .megamenu .allitem .btn {
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-top: 10px !important;
 }

 .megamenu .currentorange {
  background: #fea530 !important;
 }


 .fade-menu-enter-active,
.fade-menu-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.fade-menu-enter-from,
.fade-menu-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-menu-enter-to,
.fade-menu-leave-from {
  opacity: 1;
  transform: translateY(0);
}



.date-picker-wrapper {
  display: flex;
  justify-content: flex-start;
  margin: 20px 0;
}

.filter-block {
  display: flex;
  align-items: center;
  background: #f9f9f9;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  padding: 10px 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filter-label {
  font-weight: 500;
  margin-right: 10px;
  font-size: 14px;
  color: #606266;
  max-width: 100%;
}

.filter-input {
  padding: 6px 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  transition: border-color 0.2s ease-in-out;
}

.filter-input:focus {
  border-color: #409eff;
  outline: none;
  box-shadow: 0 0 3px rgba(64, 158, 255, 0.3);
}


.el-card.is-always-shadow:hover {
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.15);
  transition: box-shadow 0.3s ease;
  background: #fff;
}
</style> 
